import Check from "../../../../assets/images/success.gif";

const ConnectedExchange = ({ community }) => {
  return (
    <div>
      <div className="onboardingContentBox top31px">
        <p className="businessName mb25px">{community?.name.toUpperCase()}</p>
        <h2 className="title">
          <span>Exchange account connected!</span>
        </h2>
        <p className="desc">Please hold</p>
        <img alt="" className="sucessGif" src={Check} />
      </div>
    </div>
  );
};

export default ConnectedExchange;
